module.exports = __webpack_public_path__ + "img/bg03_zhTc.0753d97c.png";